import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Embed from './embed';
import reportWebVitals from './reportWebVitals';
import Teaser from './teaser';
import EmbedResults from './embed-results';
import Embed2 from "./embed copy";


const elementsToComponents = [
  { element: document.getElementById('root'), component: <App /> },
  { element: document.getElementById('embed-result'), component: <EmbedResults /> },
  { element: document.getElementById('embed'), component: <Embed2 /> }, // Was <Embed />
  { element: document.getElementById('embed2'), component: <Embed2 /> },
  { element: document.getElementById('teaser'), component: <Teaser /> },
  { element: document.getElementById('tap-to-learn'), component: <Embed2 /> },
];

const target = elementsToComponents.find(({ element }) => element);

if (target) {
  const root = ReactDOM.createRoot(target.element);
  root.render(<React.StrictMode>{target.component}</React.StrictMode>);
} else {
  console.error('No root or embed element found to render the application.');
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
